module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "upload",
    attrs: {
      "md-open-from": "#upload",
      "md-close-to": "#upload"
    }
  }, [_c('md-dialog-title', [_vm._v("Profile Photo Upload")]), _vm._v(" "), _c('md-dialog-content', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "profile-photo-input"
    }
  }, [_vm._v("Profile Picture")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "id": "profile-photo-input",
      "accept": "image/*"
    },
    on: {
      "selected": function($event) {
        return _vm.onFileUpload($event)
      }
    }
  })], 1)], 1)]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog('upload')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.upload()
      }
    }
  }, [_vm._v("Upload")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbce60c2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/profile-photo.vue
// module id = 1284
// module chunks = 21